/*

Sai Maheshwar 11/11/2022 3031689933  integrated locked process
Ashraf 12/23/2022 2700524332 mapped userid from login response

*/
import pkg from '../../../../package.json'
import React, {useState, useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import Navigation from '../../../assets/images/Navigation-2.png';
import moment from 'moment';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {fetchResetPassword, resetPasswordStatus, resetMsg} from '../../../redux/reducers/Login';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {fetchRole} from '../../../redux/reducers/role';
import PageLoader from '../../../components/PageLoader';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {useForm} from 'react-hook-form';
import {TextField, FormHelperText, InputAdornment, IconButton} from '@material-ui/core';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
const ChangePassword = () => {
  const [oldPasswordShown, setOldPasswordShown] = useState(false);
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [showLoading, setshowLoading] = useState(false);
  const history = useHistory();

  const toggleOldPassword = () => {
    setOldPasswordShown(!oldPasswordShown);
  };
  const toggleNewPassword = () => {
    setNewPasswordShown(!newPasswordShown);
  };
  const toggleConfirmPassword = () => {
    setConfirmPasswordShown(!confirmPasswordShown);
  };
  const {isLoading, successMsg, errorMsg, errorValue, changePasswordStatus} = useSelector(
    ({logIn}) => logIn,
  );
  const {expiryDate} = useSelector(({logIn}) => logIn);
  const passwordExpireDate = expiryDate;
  const now = moment(new Date());
  const end = moment(passwordExpireDate);
  const days = now.diff(end, 'days');
  const dispatch = useDispatch();
  const timer = useRef();
  const user = JSON.parse(sessionStorage.getItem('userDetails'));

  useEffect(() => {
    dispatch(fetchRole());
  }, []);
  useEffect(() => {
    if (changePasswordStatus === true) {
      setshowLoading(true);
      dispatch(resetPasswordStatus());
      const previousUrl = localStorage.getItem('previousUrl') || '/';
      if(previousUrl) {
        setTimeout(() => {
          dispatch(resetMsg());
        }, 10000);
        setTimeout(() => {
          setshowLoading(false);
          history.push(previousUrl);
        }, 2000);
      }
    }
  }, [changePasswordStatus, dispatch]);
  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetMsg());
        dispatch(resetPasswordStatus());
      }, 10000);
    }
  }, [errorMsg]);
  useEffect(() => {
    return () => {
      dispatch(resetMsg());
    };
  }, []);
  const initialValues = {
    newPassword: '',
    confirmPassword: '',
    oldPassword: '',
  };
  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required('Please enter your old password'),
    newPassword: Yup.string()
      .required('Please enter your new password')
      .matches(
        /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
        'Password must contain at least 8 characters, one uppercase, one lower case, one numeric and one special case character',
      )
      .notOneOf([Yup.ref('oldPassword'), null], 'New password cannot be same as old password'),

    confirmPassword: Yup.string()
      .required('Please confirm your new password')
      .oneOf([Yup.ref('newPassword'), null], 'New password and confirm password must match'),
  });
  const {handleSubmit, errors, register} = useForm({
    mode: 'onSubmit',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  const handleResetPassword = (data) => {
    dispatch(
      fetchResetPassword({
        confirmPassword: data?.confirmPassword,
        newPassword: data?.newPassword,
        oldPassword: data?.oldPassword,
        userId: user?.userId,
      }),
    );
  };
  return (
    <div className="App">
      <div className="login-page">
        <div className="main-content">
          <div className="company-logo">
            <img src={Navigation} alt="navigation-logo" />
          </div>
          <div className="form-content">
            <h4 role="heading" aria-level="1">
              Change Password
            </h4>
            <p>
              {days >= 0 && expiryDate ?
                'Your password is expired, please choose a new password' :
                'Please choose a new password'}
            </p>
            <form onSubmit={handleSubmit(handleResetPassword)}>
              <div className="form-group reset-password-fields">
                <label>OLD PASSWORD</label>
                <TextField
                  type={oldPasswordShown ? 'text' : 'password'}
                  margin="dense"
                  variant="outlined"
                  className="form-control"
                  name="oldPassword"
                  inputRef={register}
                  fullWidth
                  error={Boolean(errors.oldPassword?.message)}
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="visible-icon"
                          aria-label="toggle password visibility"
                          onClick={toggleOldPassword}
                        >
                          {oldPasswordShown ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <FormHelperText style={{color: 'red'}} variant="outlined">
                  {errors.oldPassword?.message ? errors.oldPassword.message : ''}
                </FormHelperText>
              </div>
              <div
                className={`reset-password-fields ${
                  errors?.newPassword?.message.length > 40 ? 'new-password-fields' : 'error-password'
                }`}
              >
                <label>NEW PASSWORD</label>
                <TextField
                  type={newPasswordShown ? 'text' : 'password'}
                  margin="dense"
                  variant="outlined"
                  style={{marginTop: '20px'}}
                  className="form-control"
                  name="newPassword"
                  inputRef={register}
                  fullWidth
                  error={Boolean(errors.newPassword?.message)}
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="visible-icon"
                          aria-label="toggle password visibility"
                          onClick={toggleNewPassword}
                        >
                          {newPasswordShown ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FormHelperText style={{color: 'red'}} variant="outlined">
                  {errors.newPassword?.message ? errors.newPassword.message : ''}
                </FormHelperText>
              </div>
              <div className="form-group reset-password-fields">
                <label>CONFIRM PASSWORD</label>
                <TextField
                  type={confirmPasswordShown ? 'text' : 'password'}
                  margin="dense"
                  variant="outlined"
                  className="form-control"
                  name="confirmPassword"
                  inputRef={register}
                  fullWidth
                  error={Boolean(errors.confirmPassword?.message)}
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={toggleConfirmPassword}
                        >
                          {confirmPasswordShown ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FormHelperText style={{color: 'red'}} variant="outlined">
                  {errors.confirmPassword?.message ? errors.confirmPassword.message : ''}
                </FormHelperText>
              </div>
              {errorValue && <p style={{color: 'red',textAlign: 'center'}} >{errorValue}</p>}
              <button
                type="submit"
                className="login-btn w-100"
                onClick={() => {
                  clearTimeout(timer?.current);
                  dispatch(resetMsg());
                }}
              >
                CHANGE PASSWORD
              </button>
            </form>
          </div>
        </div>
        <div className="copyright">
          <p style={{color: '#FFFFFF'}}>&copy;2024 {pkg.version} RevOne Companies</p>
        </div>
      </div>
      {(isLoading || showLoading==true) && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} loginPage={true} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default ChangePassword;
